import {CustomBackdrop, useApi, useEffect, useParams, useState } from "../../utils/globalImports";
import ProjectSummaryComponent from "../Project/ProjectSummaryComponent";
interface ProposalSummaryProps {

}
const ProposalSummary: React.FC<ProposalSummaryProps> = ({ }) => {
  const {proposalId} = useParams();
  const [Data, SetData] = useState<{ description: string, value: number, icon: string, sectionId: number, textvalue: string | null }[]>();
  const { execute, loading } = useApi();
  const fetchData = async () => {
    try {
      const { data } = await execute<any>("get", "/project/commercials", { type: 2, id: proposalId, feestageId: null });
      SetData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <ProjectSummaryComponent data={Data || []} heading="Proposals" subHeading="Overview of proposal details and values." />
      <CustomBackdrop open={loading} />
    </div>
  );
};

export default ProposalSummary;